<template>
  <main style="opacity: 0;">
    <div class="block">
     <Paragraph
        size="small"
        :text="structure.main.data.eyelet"
        class="block__eyelet"
        data-anim="fade"
        data-view="false"
      />
      <div :data-nav="$route.params.id" data-navproject="true">
        <Title
          size="normal"
          :text="structure.main.data.title"
          data-anim="title"
          data-view="false"
          data-siblings
        />
      </div>
      <div class="block__details">
        <List
          v-if="Object.keys(structure.details.data).length > 0"
          :slots="slots"
          type="details"
        >
          <Detail
            v-if="structure.details.data.year !== ''"
            slot="0"
            :label="translate('LABEL1', $store.state.lang)"
            :text="structure.details.data.year"
            :wide="false"
          />
          <Detail
            v-if="structure.details.data.quota !== ''"
            slot="1"
            :label="translate('LABEL2', $store.state.lang)"
            :text="structure.details.data.quota"
          />
          <Detail
            v-if="structure.details.data.investors !== ''"
            slot="2"
            :label="translate('LABEL3', $store.state.lang)"
            :text="structure.details.data.investors"
          />
        </List>
      </div>

      <div class="block__content">
        <Paragraph
          size="small"
          :text="structure.main.data.text"
          data-anim="stagger-fade"
          data-view="false"
        />

        <component
          v-for="(component, key) in structure.extra"
          :key="key"
          :is="component.component"
          :data="component"
        >
        </component>
      </div>

      <div class="block__link" v-if="structure.link">
        <Link
          :text="structure.link.data.title"
          :url="structure.link.data.url"
        />
      </div>
    </div>
  </main>
</template>

<script>
import translate from '@/assets/i18n';

import Title from '@/components/text/Title.vue';
import Paragraph from '@/components/text/Paragraph.vue';
import List from '@/components/text/List.vue';
import Detail from '@/components/text/Detail.vue';
import Link from '@/components/text/Link.vue';
import BulletList from '@/components/BulletList.vue';
import BlockText from '@/components/BlockText.vue';

export default {
  name: 'Project',

  components: {
    Title,
    Paragraph,
    Detail,
    List,
    Link,
    BulletList,
    BlockText,
  },

  data() {
    return {
      translate,
    };
  },

  computed: {
    structure() {
      const parsedStructure = {
        details: null,
        link: null,
        main: null,
        extra: [],
      };

      const data = this.$store.state.firebase.investimenti.childrens[this.$store.state.routeName];
      const { lang } = this.$store.state;
      const structure = data.structure[lang];
      const s = [];
      Object.keys(structure).forEach((key) => {
        if (structure[key].component === 'ProjectDetails') {
          parsedStructure.details = structure[key];
        } else if (structure[key].component === 'ProjectsLink') {
          parsedStructure.link = structure[key];
        } else if (structure[key].component === 'OneColumnText' && parsedStructure.main === null) {
          parsedStructure.main = structure[key];
        } else {
          parsedStructure.extra.push(structure[key]);
          parsedStructure.extra.sort((a, b) => a.order - b.order);
        }
      });

      return parsedStructure;
    },

    slots() {
      const s = [];
      Object.keys(this.structure.details.data).forEach((key) => {
        const index = key === 'year' ? 0 : key === 'quota' ? 1 : 2;
        s.push(index);
      });

      s.sort((a, b) => a - b);
      return s;
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  & + .block {
    margin-top: rem(80px);
  }

  &__eyelet {
    margin-bottom: rem(70px);
  }

  &__details {
    padding-top: rem(20px);
  }

  &__content {
    p {
      margin-top: rem(60px);
    }
  }

  &__link {
    margin-top: rem(120px);
  }
}
</style>
